<h2 mat-dialog-title class="text-lg font-bold mb-1">
  Itinerario(s)
</h2>
<mat-dialog-content>
  
    <mat-tab-group>
      <mat-tab label="Itinerario">
        <div>
          <table mat-table
            mat-table
            [dataSource]="dataSourceItinerary"
            class="min-w-500 overflow-y-visible mat-elevation-z table-fixed"
            multiTemplateDataRows
          >
            <ng-container matColumnDef="det">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6"
                    (click)="toggleDetails(element)" style="margin-left: 10px;">
                    <mat-icon class="icon-size-5"
                        [svgIcon]="selectedItinerary?._id === element._id
                            ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="datetimeStart">
              <th mat-header-cell *matHeaderCellDef>Desde</th>
              <td mat-cell *matCellDef="let element">
                @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2"  appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerStartE" [(ngModel)]="element.dateTimeStart" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerStartE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartE></mat-datepicker>
                  </mat-form-field>
                }@else{
                  {{element?.dateTimeStart | FormatDateHour: false }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="datetimeEnd">
              <th mat-header-cell *matHeaderCellDef>Hasta</th>
              <td mat-cell *matCellDef="let element">
                @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2"  appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerEndE" [(ngModel)]="element.dateTimeEnd" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndE></mat-datepicker>
                  </mat-form-field>
                }@else{
                  {{element?.dateTimeEnd | FormatDateHour: false }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element" class="px-6 text-left">
                @if (element.isEditMode) {
                  <mat-slide-toggle
                    [checked]="element.statusId === 1"
                    (change)="onStatusChangeItinerary($event.checked, element)"
                    color="primary">
                  </mat-slide-toggle>
                }@else{
                  <mat-slide-toggle
                    [checked]="element.statusId === 1"
                    (change)="onitineraryStatusChange($event.checked, element)"
                    color="primary">
                  </mat-slide-toggle>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                <div class="button-container">
                  <button
                  color = "primary"
                  mat-button
                  (click)="addItinerary(3)"
                  matTooltip="Asignar Itinerario"
                  > <!--//openAddItineraryModal(existingData, 1)"-->
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    <span></span>
                  </button>
                </div>
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                <div class="button-container">
                  <button mat-icon-button (click)="onUpdateItinerary(element, i, i)" *ngIf="!element.isEditMode">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                  </button>
                  <button mat-icon-button (click)="onSaveItinerary(element, 3, i)" *ngIf="element.isEditMode"><!--openAddItineraryModal(element, 1)-->
                      <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                  </button>
                  <button mat-icon-button (click)="openDeleteItinerary(element, 3)">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsI2.length">
              <tr *ngIf="selectedItinerary?._id === element._id" class="details-row">
                  <td [attr.colspan]="displayedColumnsI2.length">
                      <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
              </tr>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsI2"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumnsI2" 
            [class.table-expanded-row]="selectedItinerary?._id === element._id"></tr>
            <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="table-detail-row"></tr>
                  
          </table>
          <ng-template #rowDetailsTemplate let-order>
            <div class="w-full">
              <table class="w-full">
                <thead>
                  <tr>
                    <th class="w-1/12">#</th>
                    <th class="w-4/12">Días</th>
                    <th class="w-6/12">Acciones</th>
                    <th class="w-1/12">
                      <div class="button-container padding-button-container">
                        <button *ngIf="!openFormAddRoutingItineraryDetail" mat-icon-button color="primary" (click)="openFormAddRoutingItineraryDetail = true" 
                          matTooltip="Nuevo Registro">
                          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                          <span></span>
                        </button>
                        <button *ngIf="openFormAddRoutingItineraryDetail" mat-icon-button color="primary" (click)="openFormAddRoutingItineraryDetail = false;"
                          matTooltip="Cerrar">
                          <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                        </button>

                        <button mat-icon-button color="primary" matTooltip="Editar" (click)="onUpdateDetailItinerary()" *ngIf="!editDetailRoutingItineraryDetail">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button color="primary" matTooltip="Guardar" (click)="onSaveDetailItinerary(3)" *ngIf="editDetailRoutingItineraryDetail">
                            <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="openFormAddRoutingItineraryDetail == true" style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                    <td></td>
                    <td>
                      <div class="mr-2">
                        <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="currentCreateRoutingItineraryDay" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      
                    </td>
                    <td>
                      <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                        <mat-select
                          [value]="currentCreateRoutingItineraryActions"
                          multiple
                          aria-label="Accion"
                          [ngModelOptions]="{ standalone: true }"
                          (selectionChange)="onActionSelectionChange($event)"
                          >
                      
                          <mat-select-trigger>
                            <div
                              cdkDropList
                              [cdkDropListData]="currentCreateRoutingItineraryActions"
                              class="flex flex-wrap gap-1"
                              (cdkDropListDropped)="dropAction($event)">
                              <mat-chip
                                *ngFor="let selected of currentCreateRoutingItineraryActions"
                                cdkDrag
                                [removable]="true"
                                class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                (removed)="removeAction(selected)">
                                {{ selected | transloco }}
                                <button matChipRemove class="ml-0 p-0">
                                  <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                </button>
                              </mat-chip>
                            </div>
                          </mat-select-trigger>
                      
                          <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                            {{ action | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button color="primary" mat-icon-button (click)="onAddToListRoutingItinerary(3)">
                          <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngFor="let item of listItineraryDetail; let i = index">
                    <td valign="center">{{(i+1)}}</td>
                    <td>
                      @if (editDetailRoutingItineraryDetail) {
                        <div class="mr-2">
                          <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                            <mat-select [(ngModel)]="item.day" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                              <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      } @else{
                        <div class="w-full mt-4 mb-4">
                          {{ getDayNames(item.day) }}
                        </div>
                      }
                    </td>
                    <td>
                      @if (editDetailRoutingItineraryDetail) {
                        <div class="mx-1">
                          <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                            <mat-select
                              [value]="item.action"
                              multiple
                              aria-label="Accion"
                              [ngModelOptions]="{ standalone: true }"
                              (selectionChange)="onActionSelectionChange($event, item)">
                          
                              <mat-select-trigger>
                                <div
                                  cdkDropList
                                  [cdkDropListData]="item.action"
                                  class="flex flex-wrap gap-1"
                                  (cdkDropListDropped)="dropAction($event, item)">
                                  <mat-chip
                                    *ngFor="let selected of item.action"
                                    cdkDrag
                                    [removable]="true"
                                    class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                    (removed)="removeAction(selected, item)">
                                    {{ selected | transloco }}
                                    <button matChipRemove class="ml-0 p-0">
                                      <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                    </button>
                                  </mat-chip>
                                </div>
                              </mat-select-trigger>
                          
                              <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                                {{ action | transloco }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      } @else {
                        {{ item.action | transloco }}
                      }
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button mat-icon-button matTooltip="Borrar" (click)="openDeleteDetailItinerary(item, i, i)" *ngIf="editDetailRoutingItineraryDetail">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Itinerario Alternativo">
        <div>
          <table
            mat-table
            [dataSource]="dataSourceItineraryAlternative"
            class="min-w-500 overflow-y-visible mat-elevation-z table-fixed"
            multiTemplateDataRows
          >
            <ng-container matColumnDef="det">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6"
                    (click)="toggleDetailsAlternative(element)" style="margin-left: 10px;">
                    <mat-icon class="icon-size-5"
                        [svgIcon]="selectedItineraryAlternative?._id === element._id
                            ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="datetimeStart">
              <th mat-header-cell *matHeaderCellDef>Desde</th>
              <td mat-cell *matCellDef="let element">
                @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2"  appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerStartE" [(ngModel)]="element.dateTimeStart" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerStartE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartE></mat-datepicker>
                  </mat-form-field>
                }@else{
                  {{element?.dateTimeStart | FormatDateHour: false }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="datetimeEnd">
              <th mat-header-cell *matHeaderCellDef>Hasta</th>
              <td mat-cell *matCellDef="let element">
                @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2"  appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerEndE" [(ngModel)]="element.dateTimeEnd" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndE></mat-datepicker>
                  </mat-form-field>
                }@else{
                  {{element?.dateTimeEnd | FormatDateHour: false }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element" class="px-6 text-left">
                @if (element.isEditMode) {
                  <mat-slide-toggle
                    [checked]="element.statusId === 1"
                    (change)="onStatusChangeItinerary($event.checked, element)"
                    color="primary">
                  </mat-slide-toggle>
                }@else{
                  <mat-slide-toggle
                    [checked]="element.statusId === 1"
                    (change)="onitineraryAlternativeStatusChange($event.checked, element)"
                    color="primary">
                  </mat-slide-toggle>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                <div class="button-container">
                  <button
                  color = "primary"
                  mat-button
                  (click)="addItinerary(4)"
                  matTooltip="Asignar Itinerario"
                  > <!--//openAddItineraryModal(existingData, 1)"-->
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    <span></span>
                  </button>
                </div>
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                <div class="button-container">
                  <button mat-icon-button (click)="onUpdateItinerary(element, i, i)" *ngIf="!element.isEditMode">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                  </button>
                  <button mat-icon-button (click)="onSaveItinerary(element, 4, i)" *ngIf="element.isEditMode"><!--openAddItineraryModal(element, 1)-->
                      <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                  </button>
                  <button mat-icon-button (click)="openDeleteItinerary(element, 4)">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsI2.length">
              <tr *ngIf="selectedItineraryAlternative?._id === element._id" class="details-row">
                  <td [attr.colspan]="displayedColumnsI2.length">
                      <ng-container *ngTemplateOutlet="rowDetailsAlternativeTemplate; context: { $implicit: row }"></ng-container>
                  </td>
              </tr>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsI2"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumnsI2" 
            [class.table-expanded-row]="selectedItineraryAlternative?._id === element._id"></tr>
            <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="table-detail-row"></tr>
          </table>
          <!-- Paginación -->

          <ng-template #rowDetailsAlternativeTemplate let-order>
            <div class="w-full">
              <table class="w-full">
                <thead>
                  <tr>
                    <th class="w-1/12">#</th>
                    <th class="w-4/12">Días</th>
                    <th class="w-6/12">Acciones</th>
                    <th class="w-1/12">
                      <div class="button-container padding-button-container">
                        <button *ngIf="!openFormAddRoutingItineraryAlternativeDetail" mat-icon-button color="primary" (click)="openFormAddRoutingItineraryAlternativeDetail = true" 
                          matTooltip="Nuevo Registro">
                          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                          <span></span>
                        </button>
                        <button *ngIf="openFormAddRoutingItineraryAlternativeDetail" mat-icon-button color="primary" (click)="openFormAddRoutingItineraryAlternativeDetail = false;"
                          matTooltip="Cerrar">
                          <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                        </button>
    
                        <button mat-icon-button color="primary" matTooltip="Editar" (click)="onUpdateDetailItineraryAlternative()" *ngIf="!editDetailRoutingItineraryAlternativeDetail">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button color="primary" matTooltip="Guardar" (click)="onSaveDetailItinerary(4)" *ngIf="editDetailRoutingItineraryAlternativeDetail">
                            <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="openFormAddRoutingItineraryAlternativeDetail == true" style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                    <td></td>
                    <td>
                      <div class="mr-2">
                        <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="currentCreateRoutingItineraryAlternativeDay" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      
                    </td>
                    <td>
                      <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                        <mat-select
                          [value]="currentCreateRoutingItineraryAlternativeActions"
                          multiple
                          aria-label="Accion"
                          [ngModelOptions]="{ standalone: true }"
                          (selectionChange)="onActionAlternativeSelectionChange($event)"
                          >
                      
                          <mat-select-trigger>
                            <div
                              cdkDropList
                              [cdkDropListData]="currentCreateRoutingItineraryAlternativeActions"
                              class="flex flex-wrap gap-1"
                              (cdkDropListDropped)="dropActionAlternative($event)">
                              <mat-chip
                                *ngFor="let selected of currentCreateRoutingItineraryAlternativeActions"
                                cdkDrag
                                [removable]="true"
                                class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                (removed)="removeActionAlternative(selected)">
                                {{ selected | transloco }}
                                <button matChipRemove class="ml-0 p-0">
                                  <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                </button>
                              </mat-chip>
                            </div>
                          </mat-select-trigger>
                      
                          <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                            {{ action | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button color="primary" mat-icon-button (click)="onAddToListRoutingItinerary(4)">
                          <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngFor="let item of listItineraryAlternativeDetail; let i = index">
                    <td valign="center">{{(i+1)}}</td>
                    <td>
                      @if (editDetailRoutingItineraryAlternativeDetail) {
                        <div class="mr-2">
                          <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                            <mat-select [(ngModel)]="item.day" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                              <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      } @else{
                        <div class="w-full mt-4 mb-4">
                          {{ getDayNames(item.day) }}
                        </div>
                      }
                    </td>
                    <td>
                      @if (editDetailRoutingItineraryAlternativeDetail) {
                        <div class="mx-1">
                          <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                            <mat-select
                              [value]="item.action"
                              multiple
                              aria-label="Accion"
                              [ngModelOptions]="{ standalone: true }"
                              (selectionChange)="onActionSelectionChange($event, item)">
                          
                              <mat-select-trigger>
                                <div
                                  cdkDropList
                                  [cdkDropListData]="item.action"
                                  class="flex flex-wrap gap-1"
                                  (cdkDropListDropped)="dropAction($event, item)">
                                  <mat-chip
                                    *ngFor="let selected of item.action"
                                    cdkDrag
                                    [removable]="true"
                                    class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                    (removed)="removeAction(selected, item)">
                                    {{ selected | transloco }}
                                    <button matChipRemove class="ml-0 p-0">
                                      <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                    </button>
                                  </mat-chip>
                                </div>
                              </mat-select-trigger>
                          
                              <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                                {{ action | transloco }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      } @else {
                        {{ item.action | transloco }}
                      }
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button mat-icon-button matTooltip="Borrar" (click)="openDeleteDetailItineraryAlternative(item, i, i)" *ngIf="editDetailRoutingItineraryAlternativeDetail  ">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </div>
      </mat-tab>
    </mat-tab-group>
  
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
</mat-dialog-actions>
  